import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import type { SkillsImportProficiency } from '@core/tellent-skills-types';
import {
  ButtonComponent,
  ChipsComponent,
  DropdownItemComponent,
  FormFieldComponent,
  IconComponent,
  InputComponent,
  LabelComponent,
  MultiselectFeatureDirective,
  MultiSelectTriggerComponent,
  SearchFeatureDirective,
  Select2Component,
  type Select2Item,
  Select2ListItemDirective,
  Select2SelectedItemDirective,
  SelectedItemCounterDirective,
  TextareaComponent,
} from '@core/user-interface-legacy';

export type ProficiencyEditFormSaveEvent = {
  name: string;
  description: string | null;
  positions: string[];
};

@Component({
  selector: 'tlc-proficiency-edit-form',
  templateUrl: './proficiency-edit-form.component.html',
  styleUrl: './proficiency-edit-form.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ChipsComponent,
    DropdownItemComponent,
    FormFieldComponent,
    IconComponent,
    InputComponent,
    LabelComponent,
    MultiselectFeatureDirective,
    MultiSelectTriggerComponent,
    ReactiveFormsModule,
    SearchFeatureDirective,
    Select2Component,
    Select2ListItemDirective,
    Select2SelectedItemDirective,
    SelectedItemCounterDirective,
    TextareaComponent,
    TranslatePipe,
  ],
})
export class ProficiencyEditFormComponent {
  public readonly proficiency = input.required<SkillsImportProficiency>();
  public readonly positionItems = input.required<Array<Select2Item<string>>>();
  public readonly save = output<ProficiencyEditFormSaveEvent>();
  public readonly cancel = output();

  public readonly form = new FormGroup({
    name: new FormControl<string>('', { nonNullable: true }),
    description: new FormControl<string | null>(null),
    positions: new FormControl<string[]>([], { nonNullable: true }),
  });

  constructor() {
    effect(() => {
      const proficiency = this.proficiency();
      this.form.setValue({
        name: proficiency.name,
        description: proficiency.description,
        positions: proficiency.positions
          .map(position => position.positionName)
          .filter((name): name is string => name !== null),
      });
    });
  }

  public onSave(): void {
    this.save.emit(this.form.getRawValue());
  }
}
